import LandingPageForm from '../components/LandingPageForm';

export default function FlyerLandingPage() {
  return (
    <LandingPageForm 
      cityName="Los Angeles County"
      neighborhood="Los Angeles County"
      sourceTag="qr-neighbor"
      headline="We're Now Servicing Your Neighborhood. Let Us Take Care of Your Property Too."
      description="Your neighbors trust us with their exterior property care. Schedule a complimentary assessment and see the difference."
      pageTitle="Neighbor Flyer | Sunlight Grounds Care"
    />
  );
}
